import React from "react";
import { useCustomerModel } from "../customerModel";
import { ISearchValue, SearchTypeEnum } from "../../../../components/YhPageHeader/Types";
import { YhPageHeader } from "../../../../components/YhPageHeader";

const searchFields = [
    {
        type: SearchTypeEnum.Input,
        xxl: 4,
        span: 4,
        placeholder: "客户编码",
        fieldName: "code",
        size: "small",
        disabled: false
    },
    {
        type: SearchTypeEnum.Input,
        xxl: 4,
        span: 4,
        placeholder: "客户名称",
        fieldName: "name",
        size: "small",
        disabled: false
    },
    {
        type: SearchTypeEnum.Select,
        xxl: 4,
        span: 4,
        placeholder: "客户状态",
        fieldName: "status",
        size: "small",
        disabled: false,
        options: [{ label: "正常", value: "0" }, { label: "非正常", value: "9" }]
    },
]

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        loadData,
        resetSearchParam
    } = useCustomerModel();

    return (
        <YhPageHeader
            title="客户管理"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}